import axios from 'axios'

const state = {
  list: [],
  load: true,
};
const mutations = {
  add(state, item) {
    state.list.push(item);
  },
  err(state, text) {
    state.error = true;
    state.errorText = text;
    state.load = false;
    state.dataUploaded = false;
  }
};
const actions = {
  get(context, d) {
    if (d.c1 === d.c2) {
      context.state.list.push({
        date: d.date,
        c1: d.c1,
        c2: d.c2,
        course: 1,
        callback: [],
      });
      if (d.callback) d.callback(context.getters.rate(d.date, d.c1, d.c2));
      return;
    }
    let item = context.getters.rate(d.date, d.c1, d.c2);
    if (item) {
      if (item.course) {
        if (d.callback) d.callback(context.getters.rate(d.date, d.c1, d.c2));
      } else {
        if (d.callback) item.callback.push(d.callback);
      }
      return;
    }
    context.state.list.push({
      date: d.date,
      c1: d.c1,
      c2: d.c2,
      course: 0,
      callback: [],
    });
    if (d.c1 === d.c2) {
      item.course = 1;
      if (d.callback) d.callback(item);
      item.callback.forEach(i => {
        i(item);
      });
      return;
    }
    axios({
      method: 'get',
      url: '/tourclient/currencyRates?currencyId=' + d.c1 + '&secondCurrencyId=' + d.c2 + '&date.Serialized=' + d.date + '&_=' + new Date().getTime()
    }).then(r => {
      item = context.getters.rate(d.date, d.c1, d.c2);
      if (r.data && r.data.ResultQueryInfo && r.data.ResultQueryInfo.HasError) {
        window.app.$notify.warning({
          message: r.data.ResultQueryInfo.UserMessages,
        });
        item.course = 1;
        if (d.callback) d.callback(item);
        item.callback.forEach(i => {
          i(item);
        });
        return;
      }
      item.course = r.data.Value ? r.data.Value : 1;
      if (d.callback) {
        d.callback(item);
        item.callback.forEach(i => {
          i(item);
        });
      }
    }).catch(e => {
      console.log(e);
      item = context.getters.rate(d.date, d.c1, d.c2);
      context.state.list.splice(context.state.list.indexOf(item), 1);
      window.app.$notify.warning({
        message: 'Не удалось получить курс',
      });
      context.dispatch('error', e, { root: true });
    });
  },
};
const getters = {
  rate: (state) => (date, c1, c2) => {
    if (c1 === c2) return { date: date, c1: c1, c2: c2, course: 1 };
    return state.list.filter(i => {
      return date === i.date && c1 === i.c1 && c2 === i.c2;
    })[0];
  },
};


export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
